export const translations = {
  eventEditor: {
    createEvent: {
      'en-150': 'Create',
      'sk-SK': 'Vytvoriť'
    },
    updateEvent: {
      'en-150': 'Update',
      'sk-SK': 'Uložiť zmeny'
    },
    softRemoveEvent: {
      'en-150': 'Cancel event',
      'sk-SK': 'Zrušiť udalosť'
    },
    hardRemoveEvent: {
      'en-150': 'Remove event',
      'sk-SK': 'Odstrániť udalosť'
    },
    returnToEvents: {
      'en-150': 'Dismiss and return',
      'sk-SK': 'Zahodiť zmeny'
    },
    titleLabel: {
      'en-150': 'Event name',
      'sk-SK': 'Názov udalosti'
    },
    contentLabel: {
      'en-150': 'Event content',
      'sk-SK': 'Popis udalosti'
    },
    journalistsLabel: {
      'en-150': 'Journalists',
      'sk-SK': 'Redaktori'
    },
    restoreEvent: {
      'en-150': 'Restore event',
      'sk-SK': 'Obnoviť udalosť'
    },
    confirmRemoveLabel: {
      'en-150': 'I want to remove this event',
      'sk-SK': 'Chcem odstrániť túto udalosť'
    },
    softRemoveTooltip: {
      'en-150':
        'This action will cancel the event. Everyone else will see this event as cancelled.',
      'sk-SK': 'Táto akcia zruší udalosť. Všetci ostatní budú vidieť túto udalosť ako zrušenú.'
    },
    hardRemoveTooltip: {
      'en-150':
        'This action will remove the event from the Calendarium. Nobody else will see this event anymore. This is a permanent deletion.',
      'sk-SK':
        'Táto akcia zmaže celú udalosť z Kalendária. Nikto iný nebude schopný túto udalosť vidieť. Táto akcia je nezvratná.'
    },
    restoreTooltip: {
      'en-150': 'This action restores the cancelled event. The event will be shown as usual.',
      'sk-SK': 'Táto akcia obnoví udalosť. Po obnovení bude táto udalosť zobrazená normálne.'
    },
    editingLabel: {
      'en-150': 'Edit event',
      'sk-SK': 'Upraviť udalosť'
    },
    addingLabel: {
      'en-150': 'Create event',
      'sk-SK': 'Vytvoriť udalosť'
    },
    eventHashtag: {
      'en-150': 'event',
      'sk-SK': 'udalosť'
    },
    additionalTimesLabel: {
      'en-150': 'Additional times',
      'sk-SK': 'Ďalšie časy'
    },
    addTimeLabel: {
      'en-150': 'Add another time',
      'sk-SK': 'Pridať ďalší čas'
    },
    linkLabel: {
      'en-150': 'Insert a web-link for the event',
      'sk-SK': 'Vložiť link pre udalosť.'
    },
    linkTooltip: {
      'en-150':
        'It is possible to add more information about the event through a link. This link will appear next to the "method" of event creation (as a brick). Link should start with "http://", "https://"',
      'sk-SK':
        'Tu je možné poskytnúť viac udalostí pre danú udalosť prostredníctvom linku. Tento link sa zobrazí vedľa "spôsobu" zhotovenia udalosti (ako tehlička). Link by mal začínať "http://", "https://".'
    }
  }
}
